import React from 'react';
import { Form } from 'react-bootstrap';
import { Editor } from '@tinymce/tinymce-react';

const TinyMCEEditor = ({ 
  label,
  value, 
  onChange, 
  error = null, 
  disabled = false,
  required = false,
  placeholder = "Digite seu conteúdo aqui...",
  height = 300
}) => {
  const handleEditorChange = (content) => {
    onChange(content);
  };

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && '*'}
      </Form.Label>
      
      <div className={`marketplace-tinymce-container ${error ? 'is-invalid' : ''}`}>
        <Editor
          apiKey="kcr3ptya1v4c2agur79afwoz6zjguh0ta02ztbjgpn6a43hn"
          value={value || ''}
          onEditorChange={handleEditorChange}
          disabled={disabled}
          init={{
            height: height,
            menubar: false,
            placeholder: placeholder,
            plugins: [
              'advlist autolink lists link charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code help wordcount'
            ],
            toolbar: `
              undo redo | formatselect | 
              bold italic underline strikethrough | forecolor backcolor | 
              alignleft aligncenter alignright alignjustify | 
              bullist numlist outdent indent | 
              removeformat | link | code | help
            `,
            content_style: `
              body { 
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; 
                font-size: 14px;
                line-height: 1.6;
                color: #333;
              }
            `,
            branding: false,
            elementpath: false,
            statusbar: false,
            resize: false,
            setup: (editor) => {
              editor.on('focus', () => {
                if (error) {
                  // Clear error state when user starts typing
                  onChange(editor.getContent());
                }
              });
            }
          }}
        />
      </div>
      
      {error && (
        <div className="invalid-feedback d-block">
          {error}
        </div>
      )}
      
      <Form.Text className="text-muted">
        <i className="las la-info-circle me-1" />
        Use a barra de ferramentas para formatar o texto. Suporte a HTML básico.
      </Form.Text>
    </Form.Group>
  );
};

export default TinyMCEEditor;